module.exports = __webpack_public_path__ + "img/file-pp.e0192bae.svg";